import { useEffect } from 'react'
import { usePage } from '@inertiajs/react'
import { toast } from 'sonner'
import { Toaster } from '@/components/ui/sonner'
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar'
import { ProjectSidebar } from '@/components/project-sidebar'
import { MobileSidebarTrigger } from '@/components/mobile-sidebar-trigger'

interface FlashMessages {
  success?: string
  error?: string
  notice?: string
  alert?: string
}

interface Project {
  id: number
  name: string
}

interface PageProps {
  flash?: FlashMessages
  auth: {
    user: {
      id: number
      name: string
      email: string
      admin: boolean
      super_admin?: boolean
    }
  }
  project: Project
  [key: string]: any
}

interface ProjectLayoutProps {
  children: React.ReactNode
}

export function ProjectLayout({ children }: ProjectLayoutProps) {
  const { props } = usePage<PageProps>()
  const flash = props.flash
  const auth = props.auth
  const project = props.project

  // Show toast notifications when flash messages change
  useEffect(() => {
    if (!flash) return

    if (flash.success) {
      toast.success(flash.success)
    }

    if (flash.notice) {
      toast.success(flash.notice)
    }

    if (flash.error || flash.alert) {
      const message = flash.error || flash.alert
      toast.error(message)
    }
  }, [flash])

  return (
    <>
      <Toaster position="top-right" />
      <SidebarProvider defaultOpen={true}>
        <ProjectSidebar user={auth.user} project={project} />
        <SidebarInset>
          <MobileSidebarTrigger />
          {children}
        </SidebarInset>
      </SidebarProvider>
    </>
  )
}
